// Small "X ago" formatter for visit timestamps. Coarse buckets only —
// we don't need precision past "weeks ago" for the use case.
export const relativeDate = (iso: string, now: Date = new Date()): string => {
	const then = new Date(iso)
	const diffMs = now.getTime() - then.getTime()
	const day = 24 * 60 * 60 * 1000

	if (diffMs < 0) return 'in the future'

	// Calendar-day comparison: "today" / "yesterday" reflect midnight
	// boundaries rather than 24-hour windows.
	const startToday = new Date(now)
	startToday.setHours(0, 0, 0, 0)
	const startThen = new Date(then)
	startThen.setHours(0, 0, 0, 0)
	const dayDiff = Math.round(
		(startToday.getTime() - startThen.getTime()) / day,
	)

	if (dayDiff === 0) return 'today'
	if (dayDiff === 1) return 'yesterday'
	if (dayDiff < 7) return `${dayDiff} days ago`
	if (dayDiff < 14) return 'last week'
	if (dayDiff < 60) return `${Math.floor(dayDiff / 7)} weeks ago`
	if (dayDiff < 365)
		return `${Math.floor(dayDiff / 30)} month${dayDiff < 60 ? '' : 's'} ago`
	return then.toLocaleDateString(undefined, {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
	})
}
